// courseFilterHelper.ts
import * as Yup from "yup";

export type CourseFilterType = {
  course_name: string;
  status: string;
};

export const courseFilterInitialValues: CourseFilterType = {
  course_name: "",
  status: "", // default value
};

export const courseFilterValidationSchema = Yup.object().shape({
  // optional validation, can be added if needed
});

export const courseFilterProperties = [
  {
    id: "course_name",
    type: "text",
    label: "Course Name",
    required: false,
    className: "input-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    required: false,
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    hideNone: true,
  },
];

export const table = {
  primaryData: [
    {
      title: "Name",
      value: "course_name",
      type: "configue",
    },
    {
      title: "status",
      value: "status",
    },
    {
      title: "CreatedBy",
      value: "created_by_name",
      type: "configue",
    },
    {
      title: "CreatedAt",
      value: "created_at",
      type: "configue",
    },
    {
      title: "Actions",
      width: "5%",
      sendStatus: true
    },
  ],
  secondaryData: [],
};



export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0)
    );
  });
}